export type SubscriptionSnapshot = {
  subscription_tier?: string | null;
  subscription_end?: string | Date | null;
  subscription_canceled?: boolean | null;
};

export const FREE_PLAN_TIER = "starter";

export function getSubscriptionEndDate(value?: string | Date | null) {
  if (!value) return null;

  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function isSubscriptionExpired(value?: string | Date | null, now = new Date()) {
  const endDate = getSubscriptionEndDate(value);
  return Boolean(endDate && endDate.getTime() <= now.getTime());
}

export function hasActiveProAccess(profile?: SubscriptionSnapshot | null, now = new Date()) {
  if (!profile || profile.subscription_tier !== "pro") return false;
  return !isSubscriptionExpired(profile.subscription_end, now);
}

export function formatSubscriptionEndDate(value?: string | Date | null) {
  const endDate = getSubscriptionEndDate(value);
  if (!endDate) return "the end of your current paid time";

  return new Intl.DateTimeFormat(undefined, {
    month: "long",
    day: "numeric",
    year: "numeric",
  }).format(endDate);
}

export function getPlanEndDateFromNow(planName: string) {
  const endDate = new Date();
  const normalizedPlan = planName.toLowerCase();

  if (normalizedPlan.includes("year")) {
    endDate.setFullYear(endDate.getFullYear() + 1);
  } else {
    endDate.setMonth(endDate.getMonth() + 1);
  }

  return endDate;
}

export function buildScheduledDowngradeMessage(value?: string | Date | null) {
  return `Your plan is canceled. You can still use all Pro features until ${formatSubscriptionEndDate(value)}. After that day, your account will go back to Free.`;
}
